/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropwinnersfiletoolarge4Inputs */

const en_dropwinnersfiletoolarge4 = /** @type {(inputs: Dropwinnersfiletoolarge4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The file exceeds the 25 MB limit`)
};

const de_dropwinnersfiletoolarge4 = /** @type {(inputs: Dropwinnersfiletoolarge4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Datei überschreitet das 25-MB-Limit`)
};

/**
* | output |
* | --- |
* | "The file exceeds the 25 MB limit" |
*
* @param {Dropwinnersfiletoolarge4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropwinnersfiletoolarge4 = /** @type {((inputs?: Dropwinnersfiletoolarge4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropwinnersfiletoolarge4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropwinnersfiletoolarge4(inputs)
	return de_dropwinnersfiletoolarge4(inputs)
});
export { dropwinnersfiletoolarge4 as "dropWinnersFileTooLarge" }